module.exports = __webpack_public_path__ + "media/images/form_banner-cd0008a6342967d6f3f3f8f05cbd1e4a.png";